module.exports = "https://img.xiyuyouxi.com/saas/img/rmb_icon1.21364d6a.png";